var map = {
	"./acid_originium_slug/acid_originium_slug.json": 12171,
	"./axe_armorbeast/axe_armorbeast.json": 13303,
	"./blazemist_originium_slug/blazemist_originium_slug.json": 22159,
	"./bonekrusher_ambusher/bonekrusher_ambusher.json": 27993,
	"./bonekrusher_arsonist/bonekrusher_arsonist.json": 3541,
	"./bonekrusher_ballista/bonekrusher_ballista.json": 70155,
	"./bonekrusher_executioner/bonekrusher_executioner.json": 46167,
	"./bonekrusher_infiltrator/bonekrusher_infiltrator.json": 34979,
	"./bonekrusher_pyromancer/bonekrusher_pyromancer.json": 12615,
	"./bonekrusher_raider/bonekrusher_raider.json": 25805,
	"./bonekrusher_ripptusk/bonekrusher_ripptusk.json": 85591,
	"./bonekrusher_siegeknuckles/bonekrusher_siegeknuckles.json": 34071,
	"./bonekrusher_vanguard/bonekrusher_vanguard.json": 94571,
	"./brutal_pincerbeast/brutal_pincerbeast.json": 42683,
	"./effigy/effigy.json": 63197,
	"./elite_ambusher/elite_ambusher.json": 30487,
	"./elite_executioner/elite_executioner.json": 18723,
	"./elite_raider/elite_raider.json": 91543,
	"./elite_ripptusk/elite_ripptusk.json": 38201,
	"./falsewings/falsewings.json": 87779,
	"./falsewings_alpha/falsewings_alpha.json": 20609,
	"./firemist_originium_slug/firemist_originium_slug.json": 49763,
	"./glaring_rakerbeast/glaring_rakerbeast.json": 627,
	"./grove_archer/grove_archer.json": 56503,
	"./hazefyre_axe_armorbeast/hazefyre_axe_armorbeast.json": 97663,
	"./hazefyre_claw/hazefyre_claw.json": 72867,
	"./hazefyre_tuskbeast/hazefyre_tuskbeast.json": 34627,
	"./heavy_ram/heavy_ram.json": 65963,
	"./heavy_ram_alpha/heavy_ram_alpha.json": 86519,
	"./heavy_sting/heavy_sting.json": 27771,
	"./heavy_sting_alpha/heavy_sting_alpha.json": 39931,
	"./hedron/hedron.json": 56541,
	"./hedron_delta/hedron_delta.json": 59931,
	"./imbued_quillbeast/imbued_quillbeast.json": 10327,
	"./indigenous_pincerbeast/indigenous_pincerbeast.json": 74205,
	"./marble_appendage/marble_appendage.json": 39511,
	"./marble_palecore/marble_palecore.json": 15351,
	"./marble_palesent/marble_palesent.json": 27927,
	"./mudflow/mudflow.json": 81576,
	"./mudflow_delta/mudflow_delta.json": 17191,
	"./prism/prism.json": 95727,
	"./quillbeast/quillbeast.json": 14789,
	"./ram/ram.json": 20243,
	"./ram_alpha/ram_alpha.json": 24399,
	"./rhodagn/rhodagn.json": 79319,
	"./road_plunderer/road_plunderer.json": 35933,
	"./sentinel/sentinel.json": 51009,
	"./spotted_rakerbeast/spotted_rakerbeast.json": 70065,
	"./sting/sting.json": 22243,
	"./sting_alpha/sting_alpha.json": 8435,
	"./tidalklast/tidalklast.json": 97203,
	"./tidewalker/tidewalker.json": 58537,
	"./tidewalker_delta/tidewalker_delta.json": 98199,
	"./triaggelos/triaggelos.json": 11999,
	"./tunneling_nidwyrm/tunneling_nidwyrm.json": 70231,
	"./walking_chrysopolis/walking_chrysopolis.json": 34055,
	"./waterlamp/waterlamp.json": 32367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61300;